import { FormEvent, useState } from 'react';
import {
  ActionIcon,
  Button,
  Center,
  Group,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
  useMantineColorScheme,
} from '@mantine/core';

import { IconMoon, IconSunFilled } from '@tabler/icons-react';

import { useAuthContext } from '../../hooks/api/AuthProvider';

export interface LoginProps {
  onLoginSuccess?: () => void;
}

export function Login({ onLoginSuccess }: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, error } = useAuthContext();
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      await login({ username, password });
      onLoginSuccess?.();
    } catch (err) {
      // Error is already captured in the hook
      console.error('Login failed:', err);
    }
  };

  return (
    <Center
      p={8}
      h="100vh"
      bg={colorScheme === 'dark' ? 'dark' : 'white'}
      color={colorScheme === 'dark' ? 'white' : 'black'}
    >
      <Paper shadow="lg" p="lg" radius="md">
        <form onSubmit={handleSubmit}>
          <Stack gap="sm">
            <Group justify="space-between">
              <Title order={1}>Ducks</Title>
              <ActionIcon
                variant="outline"
                onClick={() =>
                  setColorScheme(colorScheme === 'dark' ? 'light' : 'dark')
                }
              >
                {colorScheme === 'dark' ? (
                  <IconSunFilled
                    style={{ width: '70%', height: '70%' }}
                    stroke={1.5}
                  />
                ) : (
                  <IconMoon
                    style={{ width: '70%', height: '70%' }}
                    stroke={1.5}
                  />
                )}
              </ActionIcon>
            </Group>
            <TextInput
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
            />

            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              disabled={loading}
            />

            {error && (
              <Text c="red" size="sm">
                {error.message}
              </Text>
            )}
            <Button
              type="submit"
              variant="outline"
              w="100%"
              loading={loading}
              disabled={loading || !username || !password}
            >
              Login
            </Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}

export default Login;
